import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-import-export',
  templateUrl: './data-import-export.component.html',
  styleUrls: ['./data-import-export.component.scss']
})
export class DataImportExportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
